function addPaymentOrderProperty(){
  var propertyChange = {
    'line': 1,
    'properties': { '_payments_reorder': false }
  }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(propertyChange)
  }).then(response => {
    return response.json();
  }).then(json => {
    console.log('Success:',json);
  }).catch((error) => {
    console.error('Error:', error);
  });
}
document.addEventListener("DOMContentLoaded", function () {  
  $.getJSON('/cart.js').then(function(cart) {
    if (!!cart.attributes.payments_test) {
      var booleanAttributesValue = JSON.parse(cart.attributes.payments_test);
      var checoutBtnDrawer = document.querySelector('button[name="checkout"]')
      var checoutBtnCart = document.querySelectorAll('button[name="checkout"]')
      var pathCart = Shopify.routes.root + 'cart'

      if (!!booleanAttributesValue && booleanAttributesValue === true ) {
        if(window.location.pathname === pathCart){
          if (!!checoutBtnCart[1]) {
            checoutBtnCart[1].addEventListener("click", function () {
              addPaymentOrderProperty()
            })
          }
        }
        if (!!checoutBtnDrawer) {
          checoutBtnDrawer.addEventListener("click", function () {
            addPaymentOrderProperty()
          })
        }
      }
    }
  })
});